<template>
  <div>
    <div v-show="showPassage" id="passageDetail">
      <div v-if="isCover">
        <img :src="coverImage" width="100%;"/>
      </div>
      <div id="title">{{ title }}</div>
      <div v-show="tags.length > 0" id="tags" >
        <a-tag v-for="text in tags" :key="text" color="blue">{{ text }}</a-tag>
      </div>
      <div id="info">
        <span class="info-item"><a-icon class="info-icon" type="read" />{{ readCount }}</span>
        <span class="info-item" style="cursor:pointer" v-on:click="clickLike"><a-icon :theme="likeButton" class="info-icon" type="like" />{{ likeCount }}</span>
        <span><a-icon class="info-icon" type="clock-circle" />{{ createTime }}</span>
      </div>
      <div id="content" v-hljs v-html="content"></div>
      <div style="height:50px;"></div>
    </div>
    <NotFound v-show="notFound"/>
  </div>
</template>

<script>
import axios from 'axios';
import 'highlight.js/styles/monokai-sublime.css';
import NotFound from './../common/NotFound.vue';

export default {
  name: 'PassageDetail',
  components: {
    NotFound
  },
  metaInfo() {
    return {
      title: this.title + ' - Bennu\'s Blog',
      meta: [{
        name: 'keywords',
        content: this.tags.join()
      }, {
        name: 'description',
        content: this.title
      }]
    };
  },
  data() {
    return {
      notFound: false,
      showPassage: false,
      likeButton: 'outlined',
      isCover: false,
      coverImage: '',
      title: 'Bennu\'s Blog',
      createTime: '',
      tags: [],
      content: '',
      likeCount: 1,
      readCount: 1
    };
  },
  mounted() {
    var self = this;
    axios
      .get(self.GLOBAL.host + '/passage/detail/' + this.$route.params.indexTitle)
      .then(response => {
        var res = response.data;
        if (res.code === 1000) {
          self.coverImage = res.data.coverImage;
          self.isCover = res.data.isCover;
          self.title = res.data.title;
          self.readCount = res.data.readCount;
          self.likeCount = res.data.likeCount;
          self.createTime = res.data.createTime;
          self.tags = res.data.tags;
          self.content = res.data.content;
          self.showPassage = true;
        } else if (res.code === 3000) {
          self.notFound = true;
        }
      })
      .catch(function (error) {
        self.$notification.error({
          message: '系统异常',
          description: error
        });
      });
  },
  methods: {
    clickLike() {
      if (this.likeButton === 'twoTone') {
        return;
      }
      var self = this;
      axios
        .post(self.GLOBAL.host + '/passage/like/' + self.$route.params.indexTitle)
        .then(response => {
          var res = response.data;
          if (res.code === 1000) {
            self.likeCount++;
            self.likeButton = 'twoTone';
          } else {
            self.$message.error(res.message);
          }
        })
        .catch(function (error) {
          self.$notification.error({
            message: '系统异常',
            description: error
          });
        });
    }
  }
};
</script>

<style scoped>
#passageDetail {
  max-width: 1000px;
  margin: 0 auto 0 auto;
}

#title {
  text-align: left;
  font-size: 30px;
  color: #000;
  font-weight: bolder;
  margin: 10px auto;
  padding: 0px 10px;
}

#content {
  margin: 20px auto 80px auto;
  padding: 0px 10px;
}

#info {
  text-align: left;
  margin: 10px auto;
  padding: 0px 10px;
}

.info-icon {
  margin-right: 8px;
}

.info-item {
  margin-right: 12px;
}

#tags {
  text-align: left;
  margin: 20px auto;
  padding: 0px 10px;
}

</style>
